(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name flightInformationReport.controller:FlightInformationReportCtrl
   *
   * @description
   *
   */
  angular
    .module('flightInformationReport')
    .directive('focusOn',function($timeout) {
		return {
			restrict : 'A',
			link : function(vm,$element,$attr) {
				vm.$watch($attr.focusOn,function(_focusVal) {
					$timeout(function() {
						_focusVal ? $element[0].focus() : $element[0].blur();
					});
				});
			}
		}
	})
    .controller('FlightInformationReportCtrl', FlightInformationReportCtrl);

  function FlightInformationReportCtrl(CommonMasterData,$sce, CommonLogicService) {

    var vm = this;
    vm.ctrlName = 'FlightInformationReportCtrl';

    vm.model = {
			searchPanelToggle : true,
			searchCriteria : {
				fromDate : null,
				toDate : null,
				origin : null,
				destination : null,
				flightNo : null
			},
			masterList : {
				airportList : [],
				fromDateFormatInvalid : false,
				toDateFormatInvalid : false,
				fromDateAfterToDate : false
			},
			initialSearchDone : false,
			reportDataURL : null,
			reportServerBaseUrl : null,
			token : null,
			tenant : null
		};

		// toggle search
		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
			vm.model.initialSearchDone = false;
		};

		// submit search
		vm.submitSearch = function(params) {
			searchGeneralFlightReport(params);
		};

		// on change search field
		vm.changeSearchField = function(searchParams, flag) {
			setDateValidationFlags();
//			var tempFromDate = moment(searchParams.fromDate, "DD/MM/YYYY").endOf('month').format("DD/MM/YYYY");
			var tempFromDate = moment(searchParams.fromDate, "DD/MM/YYYY");
        	if (tempFromDate != undefined && tempFromDate.toUpperCase() != "INVALID DATE") {
        		searchParams.toDate = tempFromDate;
        	}
			if (!vm.model.masterList.toDateFormatInvalid
					&& !vm.model.masterList.fromDateFormatInvalid) {
				if (istoDateBeforeFromDate()) {
					vm.model.masterList.fromDateAfterToDate = true;
				} else {
					vm.model.masterList.fromDateAfterToDate = false;
				}
			} else {
				vm.model.masterList.fromDateAfterToDate = false;
			}
		};

		function setDateValidationFlags() {
			// if from date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
				vm.model.masterList.fromDateFormatInvalid = true;
			} else {
				vm.model.masterList.fromDateFormatInvalid = false;
			}

			// if to date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
				vm.model.masterList.toDateFormatInvalid = true;
			} else {
				vm.model.masterList.toDateFormatInvalid = false;
			}
		}

		function isDateFormatInvalid(date) {
			if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
				return true;
			}
			return false;
		}

		// check from date and to date
		function istoDateBeforeFromDate() {
			return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
					.isBefore(
							moment(vm.model.searchCriteria.fromDate,
									"DD/MM/YYYY"));
		}
		;

		// search general flight report
		function searchGeneralFlightReport(param) {
			vm.model.initialSearchDone = true;
			if (isValidSearchParams(param)) {
				vm.model.searchCriteria = param;
				vm.model.searchPanelToggle = false;
				var url = CommonLogicService.getFlightInformationReportUrl(
						'flight_information_report.rptdesign', getSearchParamMap(param),vm.model.reportServerBaseUrl,vm.model.tenant);
				vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
			}
		}

		// set search param map
		function getSearchParamMap(param) {
			var searchParamMap = {};
			searchParamMap["fromDate"] = param.fromDate;
			searchParamMap["toDate"] = param.toDate;
			searchParamMap["flightNo"] = '';
			if (!!param.flightNo) {
				searchParamMap["flightNo"] = param.flightNo;
			}
			searchParamMap["origin"] = '';
			if (!!param.origin && !!param.origin.airPortCode) {
				searchParamMap["origin"] = param.origin.airPortCode;
			}
			searchParamMap["destination"] = '';
			if (!!param.destination && !!param.destination.airPortCode) {
				searchParamMap["destination"] = param.destination.airPortCode;
			}
			return searchParamMap;
		}

		function isValidSearchParams(params) {
			setDateValidationFlags();
			// if date invalid
			if (vm.model.masterList.toDateFormatInvalid
					|| vm.model.masterList.fromDateFormatInvalid) {
				return false;
			} else if (istoDateBeforeFromDate()) {
				vm.model.masterList.fromDateAfterToDate = true;
				return false;
			} else {
				vm.model.masterList.fromDateAfterToDate = false;
				return true;
			}
		}

		(function() {
			// load airport list
			CommonMasterData.getAirportList(function(airportList) {
				vm.model.masterList.airportList = airportList;
			}, function(error) {
				console.log('Airport List retrieval error!!!');
			});

			CommonMasterData.getReportBaseUrl(function(baseUrlData) {
				vm.model.reportServerBaseUrl = baseUrlData;
			}, function(error) {
				console.log('Error in getting base url');
			});

			// CommonMasterData.getNonLogingToken(function(token) {
			// 	vm.model.token = token;
			// }, function(error) {
			// 	console.log('Token retrieval error!!!');
			// });

			CommonMasterData.getTenant(function(tenant) {
				vm.model.tenant = tenant;
			}, function(error) {
				console.log('Token retrieval error!!!');
			});

//			vm.model.reportServerBaseUrl = CommonMasterData.getReportServerBaseUrl();
//
//			vm.model.token = CommonMasterData.getDummyToken();

		})();
	}
}());
